import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ApiStore } from '../../../web-services/api/api.store';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiService } from '../../../web-services/api/api.service';
import { TranslatorService } from '../../../services/translator_service';
import _ from 'lodash';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sites-menu',
  imports: [FormsModule,CommonModule,TranslatePipe,MatSelectModule,ReactiveFormsModule,MatCheckboxModule,
    RTLDivDirectiveDirective
  ],  
  templateUrl: './sites-menu.html',
  styleUrl: './sites-menu.scss',
})
export class SitesMenu {
  @ViewChild('allSelected',{static:false}) allSelected: MatOption;
	@ViewChild('selectSites',{static:false}) selectSites: MatSelect;
  user_data: any;
  close: any;
	searchUserForm: FormGroup;
	formValueForUser:string = '';
	sitesListFilter: any[] = [];
	userViewedSites: any;
	sitesChosen:any;
	translationsObj:any;
  currentLang;
  usageType = 1;
	isMobile: boolean = false;
  is_view_unexecuted_work_plans:any = 0;
	isAdmin: boolean = false;
  sitesHierarchy: any[] = [];

  constructor(private fb: FormBuilder,private apiService:ApiService,private apiQuery: ApiQuery,
    private translator: TranslatorService,private responsiveService: ResponsiveService,private apiStore:ApiStore,private router: Router) {
			this.searchUserForm = this.fb.group({
				userType: new FormControl([])
			});
   }

  ngOnInit() {
    this.onResize();
		this.responsiveService.checkWidth();
    this.apiQuery.user$.subscribe((user:any) => {
			if (!user) return;
      this.user_data = user;
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
      if ((user["user_role_id"] == 2) || (user["user_role_id"] == 1) || (user["user_role_id"] == 5) || (user["user_role_id"] == 6)) {
				this.isAdmin = true;
			}
      this.is_view_unexecuted_work_plans = user["is_view_unexecuted_work_plans"];			
		});
  }

  ngAfterViewInit() {       
    this.getUserViewedSitesFromAPI();
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

  async getUserViewedSitesFromAPI(){
    let viewedSites = await this.apiService.getUserViewedSites();
    this.userViewedSites = viewedSites['usersData'].User_Viewed_Sites == null ? [] : viewedSites['usersData'].User_Viewed_Sites;
    this.apiService.getSitesList(null);
    this.apiQuery.allSitesListData$.subscribe((sitesList:any) => {
      this.sitesHierarchy = [];
      if(sitesList.length == 0) return;
      this.sitesListFilter = sitesList;	

      _.each(this.sitesListFilter, (site:any) => {
        if(this.userViewedSites.some(item => item == site.site_id)){
          site.isViewed = true;
        }else{
          site.isViewed = false;
        }
      });

      // Sort sites with isViewed first alphabetically, then others alphabetically
      this.sitesListFilter.sort((a, b) => {        
        // First sort by isViewed and linked_sites_name
        if (a.isViewed && !a.linked_sites_name && (!b.isViewed || b.linked_sites_name)) return -1;
        if (b.isViewed && !b.linked_sites_name && (!a.isViewed || a.linked_sites_name)) return 1;

        // Then sort viewed sites with linked_sites_name
        if (a.isViewed && a.linked_sites_name && (!b.isViewed || !b.linked_sites_name)) return -1;
        if (b.isViewed && b.linked_sites_name && (!a.isViewed || !a.linked_sites_name)) return 1;

        // Finally sort alphabetically by site_name
        if (a.site_name < b.site_name) return -1;
        if (a.site_name > b.site_name) return 1;
        return 0;
      });

      _.each(this.sitesListFilter, (site:any) => {
        let group:any = {
          letter : '',
          names : [],
          display: true
        };
        if(site.linked_sites_name){
          if (this.sitesHierarchy.some(sitesHierarchy => sitesHierarchy.letter == site.linked_sites_name)) {	
            _.each((this.sitesHierarchy), (sitesHierarchy) => {
              if(sitesHierarchy.letter == site.linked_sites_name){
                sitesHierarchy.names.push(site);
              }
            })
          }else{
            group.letter = site.linked_sites_name;
            group.names.push(site);
          } 
        }else{
          //group.letter = site.site_name;
          group.names.push(site);
        }
        if(group.names.length > 0){
          this.sitesHierarchy.push(group);
        }
      });

      // Add isFirstNonViewed property to the first site that meets the conditions
      let foundFirstNonViewed = false;
      // First, set all sites to false
      _.each(this.sitesHierarchy, (group) => {
        _.each(group.names, (site) => {
          site.isFirstNonViewed = false;
        });
      });

      // Then find and set the first site that meets the conditions
      _.each(this.sitesHierarchy, (group) => {
        if (!foundFirstNonViewed) {
          const hasViewedSiteInGroup = group.names.some(site => site.isViewed);
          if (!hasViewedSiteInGroup) {
            const firstNonViewedSite = group.names.find(site => !site.isViewed);
            if (firstNonViewedSite) {
              firstNonViewedSite.isFirstNonViewed = true;
              foundFirstNonViewed = true;
            }
          }
        }
      });

      if(JSON.parse(sessionStorage.getItem("chosenSites")) != null){
        let allViewedSites = this.sitesListFilter.filter((site:any) => JSON.parse(sessionStorage.getItem("chosenSites")).some(item => item.site_id == site.site_id)).map((site:any) => site);
        this.searchUserForm.controls['userType'].patchValue([
          ...allViewedSites.map(item => item)
        ]);
        _.each(allViewedSites, (site) => {
          this.tosslePerOne(site);
        });
      }else{
        if(this.userViewedSites.length == 0){
          _.each(this.sitesHierarchy, (site) => {
            site.selected = true;
          });
          this.searchUserForm.controls['userType'].patchValue([
          ...this.sitesListFilter.map(item => item),
          0
          ]);
        }else{
          //select all the sites that returned from the userviewedsites
          let allViewedSites = this.sitesListFilter.filter((site:any) => this.userViewedSites.some(item => item == site.site_id)).map((site:any) => site);
          this.searchUserForm.controls['userType'].patchValue([
            ...allViewedSites.map(item => item)
          ]);
          _.each(allViewedSites, (site) => {
            this.tosslePerOne(site);
          });
        }
      }
      this.applySitesChosenBtn();
    });
  }

  isPartOfSearchUserForm(site:any){
    return this.searchUserForm.controls['userType'].value.some((value:any) => value.site_id == site.site_id);
  }

  get firstFourSites(): any[] {
    return this.sitesListFilter
      .filter(site => site.isViewed)
      .slice(0, 4);
  }

  get remainingSites(): any[] {
    return this.sitesListFilter
      .filter(site => site.isViewed)
      .slice(4);
  }

  get hasMoreSites(): boolean {
    return this.sitesListFilter.filter(site => site.isViewed).length > 4;
  }

  get remainingSitesCount(): number {
    return this.sitesListFilter.filter(site => site.isViewed).length - 4;
  }

  toggleSelection(event: any, group: any) {
    let states = this.searchUserForm.controls['userType'].value;
    states = states ? states : [];
    if(event.checked) {
      _.each(group.names, (name) => {
        if(!states.some((state:any) => state.site_id == name.site_id)){
          states.push(name)
        }
      });
      group.selected = true;
    }else {
      _.each(group.names, (name) => {
        if(states.some((state:any) => state.site_id == name.site_id)){
          states.splice(states.findIndex((obj:any) => obj.site_id == name.site_id), 1);
        }
      });
      group.selected = false;
    }
    this.searchUserForm.controls['userType'].setValue(states);
    this.allSelected?.deselect();
    _.each(this.searchUserForm.controls['userType'].value, (value) => {
      if(value == 0){
        this.searchUserForm.controls['userType'].value.splice(this.searchUserForm.controls['userType'].value.findIndex((obj:any) => obj == 0), 1);
      }
    });
    if (this.searchUserForm.controls['userType'].value.length ==  this.sitesListFilter.length){
      this.allSelected?.select();
      if(!this.searchUserForm.controls['userType'].value.some((value:any) => value == 0)){
        this.searchUserForm.controls['userType'].value.push(0);
      }
    }
  }

  applyFilter(value: any) { 
    let filter = value['value'].toLowerCase();
    _.each(this.sitesHierarchy, (site) => {
      if(site.names.some((name:any) => name.site_name.toLowerCase().includes(filter)) || site.letter.toLowerCase().includes(filter)){
        site.display = true;
      }else{
        site.display = false;
      }
    });
  }

    tosslePerOne(selectedSite:any) {
      let allHirerachyChecked:any = null;
      _.each(this.sitesHierarchy, (site) => {
        if(site.names.length > 1){
          if(site.names.some((value:any) => value.site_id == selectedSite.site_id)){
            _.each(site.names, (name) => {
              if(this.searchUserForm.controls['userType'].value.some((value:any) => value.site_id == name.site_id)){
                if(allHirerachyChecked == null){
                  allHirerachyChecked = true;
                }
              }else{
                allHirerachyChecked = false;
              }
            });
            if(allHirerachyChecked){
              site.selected = true;
            }else{
              site.selected = false;
            }
          }
        }else if(site.names.some((value:any) => value.site_id == selectedSite.site_id)){       
          site.selected = true;
        }
      });
      this.allSelected?.deselect();
      if (this.searchUserForm.controls['userType'].value.length ==  this.sitesListFilter.length){
        this.allSelected?.select();
      }
    }

    toggleAllSelection() {
      if(this.allSelected?.selected){
        _.each(this.sitesHierarchy, (site) => {
          site.selected = true;
        });
        this.searchUserForm.controls['userType'].patchValue([
        ...this.sitesListFilter.map(item => item),
        0
        ]);
      }else{
        this.searchUserForm.controls['userType'].patchValue([]);
        _.each(this.sitesHierarchy, (site) => {
          site.selected = false;
        });
      }
    }

    launchSite(site:any){
      // First clear all selections
      this.searchUserForm.controls['userType'].setValue([]);

      if (site.names?.length > 1) {
        // If it's a group with multiple sites, select all sites in the group
        this.searchUserForm.controls['userType'].setValue(site.names);
      } else {
        // If it's a single site, just select that site
        this.searchUserForm.controls['userType'].setValue([site]);
      }

      // Update the hierarchy and group selection
      _.each(this.sitesHierarchy, (group) => {
        // Reset all groups
        group.selected = false;

        // Check if this site belongs to this group
        if (group.names.some(name => name.site_id == site.site_id)) {
          // If it's a group with multiple sites
          if (group.names.length > 1) {
            // Check if all sites in the group are selected
            const allSitesSelected = group.names.every(name => 
              this.searchUserForm.controls['userType'].value.some((value:any) => value.site_id == name.site_id)
            );

            if (allSitesSelected) {
              group.selected = true;
            }
          }
        }
      });

      // Force update the sitesListFilter to trigger color changes
      this.sitesListFilter = [...this.sitesListFilter];

      // Apply the changes
      this.applySitesChosenBtn();
    }

    toggleStar(site:any){
      site.isViewed = !site.isViewed;
    }

    isGroupAllViewed(group: any): boolean {
      return group.names.every((site: any) => site.isViewed);
    }

    toggleGroupStar(group: any) {
      const newState = !this.isGroupAllViewed(group);
      group.names.forEach((site: any) => {
        site.isViewed = newState;
      });
    }

    applySitesChosenBtn(){
      if(this.searchUserForm.getRawValue()["userType"].length == 0){
        return;
      }

      this.apiStore.update({
        filteredBasicBins: [],
        filteredDailyWorkPlan: [],
        collectionsKpis: []
      });
      this.selectSites?.close();
      this.sitesChosen = this.searchUserForm.getRawValue()["userType"];
      sessionStorage.setItem("chosenSites",JSON.stringify(this.sitesChosen));

      setTimeout(() => {
        let threeMonthsAgo = {
          site_id_list : this.sitesChosen.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
          start_date : moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:23:59')
        }
        let userGeneratedWorkplans = {
          site_id:0
        }	
        let dailyWorkplan = {
          start_date : moment().subtract(11, 'months').format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:59:59')
        }
        let collectionsStatsRequest = {
          site_id_list : this.sitesChosen.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
          start_date : moment().startOf('month').format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:59:59')
        }
        let collectionsStatsRequestKPIs = {
          site_id : 0,
          start_date : moment().startOf('month').format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:59:59')
        }
        let collectionsStatsRequestToday = {
          site_id_list : this.sitesChosen.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
          start_date : moment().format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:59:59')
        }
        let fillingsStatsRequest = {
          site_id : 0,
          start_date : moment().subtract(1, 'months').format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:59:59')
        }
        let requestVolume = {
          site_id_list : this.sitesChosen.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
          start_date : sessionStorage.getItem("collectionsMinDate"),
          end_date : sessionStorage.getItem("collectionsMaxDate")
        }
        let fillingsRequestVolume = {
          site_id : 0,
          start_date : sessionStorage.getItem("fillingsMinDate"),
          end_date : sessionStorage.getItem("fillingsMaxDate")
        }
        let request = {
          start_date : sessionStorage.getItem("collectionsMinDate"),
          end_date : sessionStorage.getItem("collectionsMaxDate")
        }
        let fillingsRequest = {
          start_date : sessionStorage.getItem("fillingsMinDate"),
          end_date : sessionStorage.getItem("fillingsMaxDate")
        }
        let requestWorkPlanAnalysis = {
          sites_list : [],
          capacity_in_percent :sessionStorage.getItem("blackStatusBin"),
          start_date : sessionStorage.getItem("insightsMinDate"),
          end_date : sessionStorage.getItem("insightsMaxDate")
        }
        let reportsWorkPlanAnalysis = {
          sites_list : [],
          capacity_in_percent :85,
          start_time : moment().subtract(14, 'days').format('YYYY-MM-DD 00:00:01'),
          end_time : moment().format('YYYY-MM-DD 23:59:59')
        }
  
        let ticketManagementRequest = {
          start_time : sessionStorage.getItem("ticketManagementMinDate"),
          end_time : sessionStorage.getItem("ticketManagementMaxDate")
        }
  
        let ticketManagementRequestByDate = {
          status_id : -1
        }
  
        let removedCollectionsStatsRequest = {
          site_id_list : this.sitesChosen.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
          start_date : sessionStorage.getItem("collectionsMinDate"),
          end_date : sessionStorage.getItem("collectionsMaxDate")
        }
  
        let analyzeBinHealthRequest = {
          start_date : moment().subtract(7,'days').format('YYYY-MM-DD 00:00:01'),
          end_date : moment().format('YYYY-MM-DD 23:59:59')
        }
  
        let viewedSites = this.sitesListFilter.filter((site:any) => site.isViewed).map((site:any) => site.site_id);
        let userParams = {
          user_id: this.user_data.user_id,
          last_viewed_site_list: viewedSites,
          is_delete_last_viewed_site_list: viewedSites.length == 0 ? 1 : 0
        };
        this.apiService.updateUserParams(userParams).subscribe(async(v:any) => {
          let userViewedSites = await this.apiService.getUserViewedSites();
  
          this.userViewedSites = userViewedSites['usersData'].User_Viewed_Sites == null ? [] : userViewedSites['usersData'].User_Viewed_Sites;
          this.sitesHierarchy = [];
  
          _.each(this.sitesListFilter, (site:any) => {
            if(this.userViewedSites.some(item => item == site.site_id)){
              site.isViewed = true;
            }else{
              site.isViewed = false;
            }
          });
  
          // Sort sites with isViewed first alphabetically, then others alphabetically
          this.sitesListFilter.sort((a, b) => {
            // First sort by isViewed and linked_sites_name
            if (a.isViewed && !a.linked_sites_name && (!b.isViewed || b.linked_sites_name)) return -1;
            if (b.isViewed && !b.linked_sites_name && (!a.isViewed || a.linked_sites_name)) return 1;
  
            // Then sort viewed sites with linked_sites_name
            if (a.isViewed && a.linked_sites_name && (!b.isViewed || !b.linked_sites_name)) return -1;
            if (b.isViewed && b.linked_sites_name && (!a.isViewed || !a.linked_sites_name)) return 1;
  
            // Finally sort alphabetically by site_name
            if (a.site_name < b.site_name) return -1;
            if (a.site_name > b.site_name) return 1;
            return 0;
          });
  
          _.each(this.sitesListFilter, (site:any) => {
            let group:any = {
              letter : '',
              names : [],
              display: true
            };
            if(site.linked_sites_name){
              if (this.sitesHierarchy.some(sitesHierarchy => sitesHierarchy.letter == site.linked_sites_name)) {	
                _.each((this.sitesHierarchy), (sitesHierarchy) => {
                  if(sitesHierarchy.letter == site.linked_sites_name){
                    sitesHierarchy.names.push(site);
                  }
                })
              }else{
                group.letter = site.linked_sites_name;
                group.names.push(site);
              } 
            }else{
              //group.letter = site.site_name;
              group.names.push(site);
            }
            if(group.names.length > 0){
              this.sitesHierarchy.push(group);
            }
          });
  
          // Add isFirstNonViewed property to the first site that meets the conditions
          let foundFirstNonViewed = false;
          // First, set all sites to false
          _.each(this.sitesHierarchy, (group) => {
            _.each(group.names, (site) => {
              site.isFirstNonViewed = false;
            });
          });
  
          // Then find and set the first site that meets the conditions
          _.each(this.sitesHierarchy, (group) => {
            if (!foundFirstNonViewed) {
              const hasViewedSiteInGroup = group.names.some(site => site.isViewed);
              if (!hasViewedSiteInGroup) {
                const firstNonViewedSite = group.names.find(site => !site.isViewed);
                if (firstNonViewedSite) {
                  firstNonViewedSite.isFirstNonViewed = true;
                  foundFirstNonViewed = true;
                }
              }
            }
          });
  
  
          //select all the sites that returned from the userviewedsites
          let allViewedSites = this.searchUserForm.controls['userType'].value;
          this.searchUserForm.controls['userType'].patchValue([
            ...allViewedSites.map(item => item)
          ]);
          _.each(allViewedSites, (site) => {
            this.tosslePerOne(site);
          });
          this.apiService.getSitesList(this.sitesChosen);
        });
        this.apiService.getfilteredUsersInfo(this.sitesChosen);
        this.apiService.getfilteredBinsInfo(this.sitesChosen);
        this.apiService.getfilteredIncludingNonActiveBinsInfo(this.sitesChosen);
        this.apiService.getAnalyzeBinHealth(this.sitesChosen,analyzeBinHealthRequest);
        this.apiService.getUserAlertsByType(this.sitesChosen);
        this.apiService.getfilteredBasicBinsInfo(this.sitesChosen);      
  
        if(this.usageType == 2){
          if(sessionStorage.getItem("fillingsMinDate")!=null && sessionStorage.getItem("fillingsMaxDate")!=null){
            this.apiService.getfilteredSiteRefillsKpis(fillingsRequest,this.sitesChosen);
            this.apiService.getfilteredBinsRefillsStats(fillingsRequestVolume,this.sitesChosen);
          }else{
            this.apiService.getfilteredSiteRefillsKpis(fillingsStatsRequest,this.sitesChosen);
            this.apiService.getfilteredBinsRefillsStats(fillingsStatsRequest,this.sitesChosen);
          }
        }
  
        if(this.usageType == 1 && this.isAdmin){
          if(sessionStorage.getItem("ticketManagementMinDate")!=null && sessionStorage.getItem("ticketManagementMaxDate")!=null &&
          sessionStorage.getItem("ticketManagementMinDate") != '' && sessionStorage.getItem("ticketManagementMaxDate") != ''){
            this.apiService.getCRTicketsList(ticketManagementRequest,this.sitesChosen);
            this.apiService.getInsTicketsList(ticketManagementRequest,this.sitesChosen);
            this.apiService.getRmTicketsList(ticketManagementRequest,this.sitesChosen);
          }else{
            this.apiService.getCRTicketsList(ticketManagementRequestByDate,this.sitesChosen);
            this.apiService.getInsTicketsList(ticketManagementRequestByDate,this.sitesChosen);
            this.apiService.getRmTicketsList(ticketManagementRequestByDate,this.sitesChosen);
          }
        }

        this.apiService.getfilteredBinsCollectionsStats(threeMonthsAgo,0,this.sitesChosen);
        this.apiService.getfilteredSiteCollectionsKpis(collectionsStatsRequestKPIs,this.sitesChosen);
        this.apiService.binsCollectionsToday(collectionsStatsRequestToday,this.sitesChosen);
        this.apiService.basicBinsMonthCollections(collectionsStatsRequest,this.sitesChosen);
        this.apiService.basicBinsTodayCollections(collectionsStatsRequestToday,this.sitesChosen);
  
        if(sessionStorage.getItem("collectionsMinDate")!=null && sessionStorage.getItem("collectionsMaxDate")!=null && this.router.url.includes("collections")){
          this.apiStore.update({ 
            allCollectionsKpis: [],
            collectionsKpis: []
          });
          this.apiService.getfilteredSiteCollectionsKpis(request,this.sitesChosen);
          this.apiStore.update({ allCollectionsStats: [] });
          this.apiStore.update({ collectionsStatsInCollections: [] });
          this.apiService.getfilteredBinsCollectionsStats(requestVolume,5,this.sitesChosen);
          this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
          this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
          this.apiService.dailyWorkPlansTotalRecommendedCollections(requestVolume);
        }
        if(sessionStorage.getItem("insightsMinDate")!=null && sessionStorage.getItem("insightsMaxDate")!=null){
          this.apiService.getWorkPlanAnalysis(requestWorkPlanAnalysis,this.sitesChosen);
        }else{
          this.apiService.getWorkPlanAnalysis(reportsWorkPlanAnalysis,this.sitesChosen);
        }
        this.apiService.getInstallationAccessoryTypes();
        this.apiService.getWorkPlanDistrebutionMethods();
        this.apiService.getDynamicWorkplan();
        this.apiService.getUnitIssuesType();
        this.apiService.getCustomerWorkPlanCollectionschedulePolicy();
        this.apiService.getfilteredSitesClustersList(userGeneratedWorkplans,this.sitesChosen);
        this.apiService.getNeighborhoodsList(userGeneratedWorkplans,this.sitesChosen);
        this.apiService.getTrucksTabletsInfo(userGeneratedWorkplans,this.sitesChosen);		
        this.apiService.getfilteredActivePlans(this.sitesChosen); 
        this.apiService.getfilteredWorkPlanScheduler(userGeneratedWorkplans,this.sitesChosen);		
        this.apiService.getDailyWorkPlanCalanderData(dailyWorkplan.start_date,dailyWorkplan.end_date,this.is_view_unexecuted_work_plans,this.sitesChosen);	
        this.apiService.getRemovedBinFromExistingWorkPlanReasonType();
        this.apiService.getTicketEventTypes();
        this.apiService.getTicketEventCause();
        this.apiService.getTicketAnalysisTypes();
        this.apiService.getSuspectedCollectionReasonTypes();
        this.apiService.getTicketRemoveOrReplaceTypes();	
        this.apiService.getNavigationOptimizationTypes();
        this.apiService.getClusterTypes();
        this.apiService.getUserRoles();
        this.apiService.getUsageTypes();
        this.apiService.getCapacityDisplayTypes();
        this.apiService.getUserAccounts();
        this.apiService.getTicketsList(this.sitesChosen);
        this.apiService.getCustomerBinTypes();
  
        this.translator.currentLangEmitter$
        .subscribe(async value=>{						
          this.translationsObj = await this.translator.getTranslation(value).toPromise();
          this.currentLang = value;	
          if(this.allSelected?.selected){
            if(this.searchUserForm.controls['userType'].value.length - 1 > 1){
              this.formValueForUser = `${this.translationsObj.TITLES.MULTI_SITES} (${this.searchUserForm.controls['userType'].value.length-1})`;
            }else if(this.searchUserForm.controls['userType'].value.length - 1 == 1){
              this.formValueForUser = this.searchUserForm.controls['userType'].value[0]["site_name"];
            }
            if(this.sitesListFilter.length == 1){
              this.searchUserForm.controls['userType'].disable();
              const boxes = Array.from(
                document.getElementsByClassName('mat-mdc-select-arrow-wrapper')
              );
              boxes.forEach((box:any) => {
                box["style"].display = 'none';
              });
            }else{
              this.searchUserForm.controls['userType'].enable();
              const boxes = Array.from(
                document.getElementsByClassName('mat-mdc-select-arrow-wrapper')
              );
              boxes.forEach((box:any) => {
                box["style"].display = 'table-cell';
              });
            }
          }else{
            if(this.searchUserForm.controls['userType'].value.length > 1){			
              this.formValueForUser = `${this.translationsObj.TITLES.MULTI_SITES} (${this.searchUserForm.controls['userType'].value.length})`;
            }else if(this.searchUserForm.controls['userType'].value.length == 1){
              this.formValueForUser = this.searchUserForm.controls['userType'].value[0]["site_name"];
            }
          }
        });
      }, 0);
    }
}
